module.exports = __webpack_public_path__ + "media/customizations/libertyatlincoln/back-629e1506fd4fc4e4f9361f2901308f7a.jpg";